import React, { useEffect, useMemo, useState } from "react";
import ReactModal from "react-modal";
import { Transition } from "react-transition-group";

// import { CloseButton } from "@/components/CloseButton";
import { CloseButton } from "../CloseButton";
// import { cx } from "@/ui/helpers";
import { cx } from "../../../helpers";

import { ModalProps } from "./types";

import styles from "./styles.module.css";

export const Modal: React.FC<ModalProps> = (props: ModalProps) => {
  const {
    size = "md",
    shape = "default",
    animation = "popper",
    centered,
    title,
    titleStyle,
    isOpen,
    children,
    bodyStyle,
    className,
    bodyClassName,
    portalClassName,
    overlayClassName,
    closeButtonClassName,
    onRequestClose,
    parentSelector,
    hideScrollOnIsOpenFalse = true,
    ...modalProps
  } = props;

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (isOpen) document.body.style.overflow = "hidden";
    else if (hideScrollOnIsOpenFalse) document.body.style.overflow = "unset";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Animation cannot run at the same time as the modal opening
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Run animation one frame after rendering the modal
    setIsTransitioning(isOpen);
  }, [isOpen]);

  const parent = useMemo(() => {
    if (typeof document === "undefined") return null;
    let parent = document.querySelector("main") || document.body;
    if (parentSelector)
      parent = document.querySelector(parentSelector) || document.body;

    return parent;
  }, []);

  if (!parent) return null;

  return (
    <Transition className="twp" enter exit in={isTransitioning} timeout={0}>
      {(state: string) => (
        <ReactModal
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          closeTimeoutMS={0}
          parentSelector={() => parent}
          className={cx(
            styles.content,
            styles[state],
            styles[size],
            styles[shape],
            centered && styles.centered,
            animation === "popper" && styles.popperAnimation,
            animation === "bottomSheet" && styles.bottomSheetAnimation,
            className,
          )}
          portalClassName={cx(styles.portal, portalClassName)}
          overlayClassName={cx(styles.overlay, overlayClassName)}
          {...modalProps}
        >
          <CloseButton
            onClick={onRequestClose}
            className={cx(
              "cy-close-btn",
              styles.closeButton,
              closeButtonClassName,
              titleStyle === "purpleGradient" && styles.purpleGradient,
            )}
          />
          {title ? (
            <div
              className={cx(
                styles.modalHeader,
                titleStyle ? styles[titleStyle] : "",
              )}
            >
              {title}
            </div>
          ) : null}
          <div
            className={cx(styles.modalBody, bodyClassName)}
            style={bodyStyle}
            data-testid={props["data-testid"]}
          >
            {children}
          </div>
        </ReactModal>
      )}
    </Transition>
  );
};
